import { rgba } from "polished";
import { useQueryParam, StringParam } from "use-query-params";

import { CenterContent, Icon } from "shared/styles";
import { copy } from "shared/assets";
import { Spacer } from "shared/layout";
import { Button, Title } from "shared/components";
import { getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { useBandRoute } from "Bands/utils";

const errorCopy = copy.subscription.error;

export const SubscriptionError = () => {
  const { icon, iconColor } = getStatus(IStatus.error);
  const { pushRoute } = useBandRoute();
  const [action] = useQueryParam("action", StringParam);

  return (
    <CenterContent>
      <Spacer size="xl" align="center">
        <Icon
          isCircle
          backgroundColor={rgba(iconColor as string, 0.25)}
          as={icon}
          height="60px"
          width="60px"
          color={iconColor}
          padding="18px"
        />
        <Title asComponent="h2">
          {action === "edit" ? errorCopy.edit : errorCopy.add}
        </Title>
        <Button
          onClick={() => pushRoute(BAND_PATHS.SUBSCRIPTION_OVERVIEW)}
          data-testid="back_button"
        >
          {errorCopy.button}
        </Button>
      </Spacer>
    </CenterContent>
  );
};
